/**
 * Avalara © 2017
 * file: engines/opus_ui/src/root.jsx
 */

import React from 'react';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import { Route, Routes } from 'react-router-dom';

const root = ({ history, store }) => (
  <Provider store={store}>
    <HashRouter>
      <Routes>
        <Route path="*" Component={App} />
      </Routes>
    </HashRouter>
  </Provider>
);

export default root;
